import Model from "./base/model";

class Driver extends Model{
  resourceName() {
    return "drivers";
  }

  fields() {
    return {
      name: "",
      cpf: "",
      rg: "",
      transporters: "",
      transporter_drivers: { jsonApi: "hasMany", type: "transporter_drivers"},
      user: { jsonApi: "hasOne", type: "users"},
      contact_phone: "",
    };
  }

  async search(data) {
    return this.request(
      this.resourceName() + "/search",
      "POST",
      {},
      data
    );
  }

  async setDriver(id, data) {
    return this.request(
      this.resourceName() + "/set/" + id,
      "POST",
      {},
      data
    );
  }
}

export default new Driver();
